import React from "react";
import SubleagueCell from "./SubleagueCell.jsx";

const SubleagueListTable =
    ({
        entries,
        columns,
        onEntryClick,
        game,
        ownSubleagues
    }) => {
        if (!entries) {
            return null;
        }
        return (
            <table className="zw-tbl ranking-sub-league">
                <TableHeader columns={columns}/>
                <tbody>
                {entries.map(
                    (entry, i) => <TableRow key={i}
                                            game={game}
                                            entry={entry}
                                            columns={columns}
                                            onClick={onEntryClick}
                                            marked={ownSubleagues && ownSubleagues.includes(entry.id)}
                    />)}
                </tbody>
            </table>
        );
    };

const TableHeader = ({columns}) => (<thead>
<tr>
    {columns.map((col, i) => <TableHeaderCell key={i} column={col}/>)}
</tr>
</thead>);

const TableHeaderCell = ({column}) => {
    let header;
    if (column.abbr) {
        header = <abbr title={column.name}>{column.abbr}</abbr>;
    } else {
        header = column.name
    }

    return <th>{header}</th>;
};

class TableRow extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.onClick(this.props.entry);
    }

    render() {
        return <tr className={"ranking-entry " + (this.props.marked ? 'ranking-entry--marked' : '')}>
            {this.props.columns.map((col, i) =>
                <SubleagueCell key={i}
                               entry={this.props.entry}
                               column={col}
                               onClick={this.handleClick}
                               marked={this.props.marked}
                />)}
        </tr>;
    }
}


SubleagueListTable.propTypes = {};

export default SubleagueListTable
